import { TextCodes } from '@api/types/translation/TextCodes';
import { Title, WarrantyProductFields } from '@components';
import { t } from '@translations';

export const WarrantyProductSection = () => {
  return (
    <>
      <Title noDot variant='h3'>
        {t(TextCodes.Warranty.Block.ProductInformation)}
      </Title>
      <WarrantyProductFields />
    </>
  );
};
